import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ManualAdjustmentForm } from 'src/components/ManualAdjustmentForm/ManualAdjustmentForm';

interface ManualAdjustmentProcedurePropsType {
    customerId: number;
    onQueryAudits: () => void;
}

export const ManualAdjustmentProcedure = observer(
    'ManualAdjustmentProcedure',
    ({ customerId, onQueryAudits }: ManualAdjustmentProcedurePropsType) => {
        return (
            <ManualAdjustmentForm
                customerId={customerId}
                submitCallback={onQueryAudits}
            />
        );
    }
);
